import {Component} from '@angular/core';

@Component({
  selector: 'logo',
  template: `
  <ng-content></ng-content>
  `
})
export class LogoComponent {

}



// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/free/navbars/logo.component.ts